<template>
  <div class="step">
    <h2>뱃지 종류 선택</h2>
    <div class="itemBox clearFix">
      <ul class="itemBtns">
        <li
          class="itemBtn"
          :class="{ active: badge.pin > 0 }"
          @click="checkBadge('pin', badge.pin)"
          @keydown="checkBadge('pin', badge.pin)"
        >
          <div>
            <p>핀 뱃지</p>
            <hr />
            <img
              v-if="badge.pin > 0"
              class="item_img"
              src="@/assets/goods/badge_active.svg"
              alt=""
            />
            <img v-else class="item_img" src="@/assets/goods/badge_nomal.svg" alt="" />
          </div>
        </li>
        <li
          class="itemBtn"
          :class="{ active: badge.tongs > 0 }"
          @click="checkBadge('tongs', badge.tongs)"
          @keydown="checkBadge('tongs', badge.tongs)"
        >
          <div>
            <p>집게핀 뱃지</p>
            <hr />
            <img
              v-if="badge.tongs > 0"
              class="item_img"
              src="@/assets/goods/badge_tongs_active.svg"
              alt=""
            />
            <img v-else class="item_img" src="@/assets/goods/badge_tongs_nomal.svg" alt="" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    badge: {
      type: Object,
    },
  },
  methods: {
    checkBadge(color, num) {
      this.$emit('checkBadge', color, num)
    },
  },
}
</script>

<style scoped lang="scss">
.step {
  width: 575px;
  margin: 0 auto 100px;
  > h2 {
    font-weight: 700;
    font-size: 26px;
    color: #848484;
    margin-bottom: 27px;
  }

  > .itemBox {
    font-weight: 400;

    > .itemBtns {
      float: left;

      > li {
        width: 180px;
        height: 240px;
        border: 2px solid #bcbcbc;
        border-radius: 10px;
        float: left;
        box-sizing: border-box;
        margin-right: 14px;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }

        &.active {
          border: 2px solid #ff6699;
          background-color: #fff7fa87;
        }

        > div {
          width: 121px;
          margin: 26px auto 0;
          text-align: center;
          vertical-align: middle;

          > p {
            font-size: 16px;
            color: #707070;
            margin-bottom: 2px;
            text-align: left;
          }

          > span {
            font-size: 10px;
            color: #707070;
          }

          > hr {
            width: 100%;
            border: 1px solid #e6e6e6;
            margin-top: 14px;
          }

          > img {
            margin: 25px 10px;
            width: 100px;
            height: 100px;
            vertical-align: middle;
            float: right;
          }
        }
      }
    }
  }
}
</style>
